'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { nanoid } from 'nanoid';
import { Button, TextField } from '../../index.js';
export const Search = React.forwardRef((props, ref) => {
    const { className, label, id, clearButtonLabelText = 'clear' } = props;
    const componentClassName = classnames('sparky-c-search', className, {});
    const [searchId, setSearchId] = React.useState();
    const [showClear, setShowClear] = React.useState(false);
    const setSearchRef = React.useRef(null);
    const searchRef = ref ? ref : setSearchRef;
    function clearInput() {
        if (searchRef) {
            searchRef.current.value =
                '';
        }
        setShowClear(false);
    }
    React.useEffect(() => {
        var _a;
        setSearchId(id || nanoid());
        (_a = searchRef === null || searchRef === void 0 ? void 0 : searchRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('input', () => {
            searchRef.current.value
                .length > 0
                ? setShowClear(true)
                : setShowClear(false);
        });
    }, [id, showClear, searchRef]);
    return (_jsxs("div", Object.assign({ className: componentClassName, role: "search", "aria-labelledby": `${id}-label` }, { children: [_jsx(TextField, { floating: false, className: "sparky-c-search__text-field", type: "search", placeholder: label, label: null, id: searchId, ref: searchRef }), showClear && (_jsx(Button, { className: "sparky-c-search__clear-button", onClick: clearInput, type: "button", variant: "bare", iconName: "x", "aria-label": clearButtonLabelText }))] })));
});
Search.displayName = 'Search';
//# sourceMappingURL=Search.js.map